import { useMemo } from 'react';

import { useShallow } from 'zustand/shallow';

import { formatDaysToDateRange } from '@/shared/lib/format/dateTime';

import type { AssetQualityTabValue } from './types';
import { useAssetQualityFilterStore } from './useAssetQualityFilterStore';

type UseAssetQualityApiParamsParams = {
  tabValue: AssetQualityTabValue;
  page: number;
  pageSize: number;
};

export const useAssetQualityApiParams = ({ tabValue, page, pageSize }: UseAssetQualityApiParamsParams) => {
  const { table, column } = useAssetQualityFilterStore(
    useShallow((state) => ({ table: state.table, column: state.column }))
  );

  const filterState = tabValue === 'table' ? table : column;

  const dateRange = useMemo(() => {
    return formatDaysToDateRange(filterState.selectedDateRangeValue, 1);
  }, [filterState.selectedDateRangeValue]);

  const apiParams = useMemo(
    () => ({
      tableId: filterState.selectedTableValue !== 'All' ? parseInt(filterState.selectedTableValue) : undefined,
      columnName: filterState.selectedColumnNameValue !== 'All' ? filterState.selectedColumnNameValue : undefined,
      dataZone: filterState.selectedDataZoneValue !== 'All' ? filterState.selectedDataZoneValue : undefined,
      qualityLevel: filterState.selectedDataQualityValue !== 'All' ? filterState.selectedDataQualityValue : undefined,
      fromDate: dateRange.startDate,
      toDate: dateRange.endDate,
      sortBy: filterState.selectedSortByValue,
      page,
      pageSize,
    }),
    [filterState, dateRange, page, pageSize]
  );

  return apiParams;
};
